import { IS_TEST_RUNNER, ORIGIN } from '#src/config.ts';

// Bridge serves its hosted pages from several subdomains (dashboard.*,
// compliance.*, …), so trust any https origin under bridge.xyz rather than an
// exhaustive list. Only Bridge controls that domain, so this stays safe against
// postMessage injection.
export const isAllowedBridgeOrigin = (origin: string): boolean => {
  // Storybook / tests render the mock page from a data: URL (origin "null").
  if (IS_TEST_RUNNER && (origin === 'null' || origin === ORIGIN)) return true;

  try {
    const { protocol, hostname } = new URL(origin);
    return (
      protocol === 'https:' &&
      (hostname === 'bridge.xyz' || hostname.endsWith('.bridge.xyz'))
    );
  } catch {
    return false;
  }
};

export const OFF_RAMP_ONBOARDING_PATH = '/onboarding/offramp-kyc';
